export const initSlider = (slider) => {
    const container = slider.querySelector('.js-slider-container');
    const track = slider.querySelector('.js-slider-track');

    const triggers = [...slider.querySelectorAll('.js-slider-trigger')].filter((trigger) => trigger.closest('.js-slider') === slider);

    let current = 0;
    let size = track.childElementCount;

    const touch = {
        startX: 0, endX: 0,
        startY: 0, endY: 0,
    };

    const goToSlide = (index) => {
        if(index < 0) {
            index = 0;
        }

        if(index > (size - 1)) {
            index = (size - 1);
        }

        current = index;
        track.style.setProperty('--x', current);

        updateTriggerStates();
    };

    const toPrevious = (e = null) => {
        if(e) {
            e.preventDefault();
        }

        if(current > 0) {
            goToSlide(current - 1);
        }
    };

    const toNext = (e = null) => {
        if(e) {
            e.preventDefault();
        }

        if(current < size) {
            goToSlide(current + 1);
        }
    };

    const touchStartHandler = (e) => {
        if(e.target.closest('.js-slider-track') !== track) {
            return;
        }

        touch.startX = e.changedTouches[0].screenX;
        touch.startY = e.changedTouches[0].screenY;

        document.addEventListener('touchend', touchEndHandler);
    };

    const touchEndHandler = (e) => {
        touch.endX = e.changedTouches[0].screenX;
        touch.endY = e.changedTouches[0].screenY;

        const xDiff = Math.abs(touch.startX - touch.endX);
        const yDiff = Math.abs(touch.startY - touch.endY);

        if(xDiff > yDiff) {
            if(touch.endX > touch.startX) {
                toPrevious();
            } else if(touch.endX < touch.startX) {
                toNext();
            }
        }

        document.removeEventListener('touchend', touchEndHandler);
    };

    const updateTriggerStates = () => {
        triggers.map((trigger) => {
            let isDisabled = false;
            let isCurrent = false;

            if(trigger.hasAttribute('data-prev') && current === 0) {
                isDisabled = true;
            }

            if(trigger.hasAttribute('data-next') && current === size - 1) {
                isDisabled = true;
            }

            if(trigger.hasAttribute('data-index') && current === +trigger.dataset.index) {
                isCurrent = true;
            }

            if(isDisabled) {
                trigger.setAttribute('disabled', '');
            } else {
                trigger.removeAttribute('disabled');
            }

            if(isCurrent) {
                trigger.setAttribute('data-current', '');
            } else {
                trigger.removeAttribute('data-current');
            }
        });
    }

    if(track.children.length > 0 && track.scrollWidth > container.clientWidth) {

        track.style.setProperty('--c', `${track.firstElementChild.clientWidth}px` || '');

        const slidesInView = container.clientWidth / track.firstElementChild.clientWidth;

        size -= (slidesInView - 1);

        updateTriggerStates();

        triggers.map((trigger) => {
            trigger.classList.remove('d-none');

            if(trigger.hasAttribute('data-prev')) {
                trigger.addEventListener('click', toPrevious);
            } else if(trigger.hasAttribute('data-next')) {
                trigger.addEventListener('click', toNext);
            } else if(trigger.hasAttribute('data-index')) {
                trigger.addEventListener('click', (e) => {
                    e.preventDefault();
                    goToSlide(+trigger.dataset.index)
                });
            }
        });

        track.addEventListener('touchstart', touchStartHandler, {passive: true});
    } else {
        triggers.map((trigger) => trigger.classList.add('d-none'))
    }
};

// A delay to load images, otherwise the width isn't correct later on
setTimeout(() => {
    [...document.querySelectorAll('.js-slider')].map(initSlider);
}, 300);
